import { isMobile } from "lib/modules/util";

export default {
	mounted(el, binding) {
		if (binding.value === false || isMobile)
			return;

		let inputEl = el;

		if (!["INPUT", "TEXTAREA", "SELECT"].includes(el.nodeName))
			inputEl = el.querySelector("input, textarea, select");

		if (inputEl)
			inputEl.focus();
	}
};
